var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 237,
    height: 86,
    viewBox: "0 0 237 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_118_5747)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.187 69.9623L130.992 85.4203V31.4956L115.809 52.7608L67.187 40.981V69.9623Z",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7637 69.5082L130.415 84.6868V33.2936L116.276 53.0983C116.13 53.3012 115.879 53.3812 115.653 53.3167L67.7637 41.7146V69.5082ZM130.859 85.982L67.105 70.5362C66.8255 70.4962 66.6106 70.2544 66.6106 69.9623V40.981H66.6129C66.6129 40.9369 66.6181 40.8922 66.6287 40.8473C66.702 40.5372 67.0116 40.3456 67.32 40.4194L115.568 52.1084L130.496 31.1996C130.597 31.0296 130.781 30.9158 130.992 30.9158C131.31 30.9158 131.568 31.1755 131.568 31.4956V85.4203H131.566C131.566 85.4645 131.561 85.5092 131.55 85.554C131.477 85.8642 131.167 86.0557 130.859 85.982Z",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.008 0.57959L169.813 16.0376L130.992 31.4956L79.5251 19.0268L106.008 0.57959Z",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.008 0.57959L169.813 16.0376L130.992 31.4956L106.008 25.4428V0.57959Z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.813 69.9623L130.992 85.4203V31.4956L147.712 50.0549L169.813 41.2545V69.9623Z",
    fill: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.004 70.5095L131.203 85.9593C130.907 86.0769 130.573 85.9308 130.456 85.6332C130.428 85.5633 130.415 85.4912 130.415 85.4203L130.415 31.4956C130.415 31.1755 130.673 30.9158 130.992 30.9158C131.18 30.9158 131.348 31.0071 131.453 31.1481L147.868 49.3692L169.601 40.7156C169.897 40.598 170.232 40.7441 170.348 41.0416C170.376 41.1116 170.389 41.1836 170.389 41.2545L170.389 69.9623C170.389 70.2151 170.228 70.4302 170.004 70.5095ZM131.568 84.5674L169.236 69.5686V42.1074L147.923 50.5939L147.922 50.5919C147.706 50.6777 147.451 50.6257 147.286 50.4422L131.568 32.9954V84.5674Z",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.237 49.4638L140.853 60.7655L130.992 31.4956L147.712 50.0549L169.237 41.484V49.4638Z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.19 0.0299055L169.945 15.476C170.254 15.5497 170.444 15.8611 170.371 16.1713C170.326 16.3619 170.192 16.5076 170.023 16.5746L170.024 16.5766L131.203 32.0346C131.072 32.0866 130.933 32.087 130.809 32.0454L67.054 16.5993C66.7456 16.5256 66.5552 16.2141 66.6285 15.904C66.6735 15.7134 66.8077 15.5677 66.976 15.5006L66.9752 15.4987L105.796 0.0406194C105.927 -0.0114348 106.066 -0.0117484 106.19 0.0299055ZM167.912 16.1711L106.054 1.18458L69.0873 15.9042L130.946 30.8907L167.912 16.1711Z",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.0049 37.3028L115.809 52.7608L130.992 31.4956L67.1872 16.0376L52.0049 37.3028Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9691 36.9426L115.568 52.1085L130.027 31.856L67.4286 16.69L52.9691 36.9426V36.9426ZM115.677 53.3226L51.8925 37.8696C51.8143 37.8539 51.7382 37.8216 51.6693 37.7717C51.4118 37.5854 51.3533 37.2243 51.5387 36.9654L66.7209 15.7002C66.853 15.5161 67.0869 15.4202 67.3201 15.476L131.104 30.929C131.182 30.9447 131.258 30.977 131.327 31.0268C131.585 31.2132 131.643 31.5742 131.458 31.8332L116.276 53.0984C116.144 53.2824 115.91 53.3783 115.677 53.3226Z",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.533 34.5969L147.712 50.0549L130.992 31.4956L169.813 16.0376L186.533 34.5969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.744 35.1359L147.923 50.5939C147.677 50.6918 147.404 50.6071 147.252 50.4045L130.566 31.883C130.353 31.6467 130.372 31.2814 130.607 31.0676C130.659 31.0196 130.718 30.9834 130.781 30.9587L130.78 30.9567L169.601 15.4987C169.847 15.4008 170.12 15.4855 170.272 15.6882L186.958 34.2096C187.171 34.4459 187.153 34.8111 186.918 35.025C186.865 35.073 186.806 35.1092 186.744 35.1339L186.744 35.1359ZM147.869 49.3693L185.549 34.3652L169.656 16.7234L131.975 31.7274L147.869 49.3693Z",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.272 60.5795L102.76 65.1893C104.652 65.6611 106.2 64.3947 106.2 62.3748C106.2 60.3549 104.652 58.3165 102.76 57.8447L84.272 53.2349C82.3799 52.7631 80.832 54.0296 80.832 56.0495C80.832 58.0694 82.3799 60.1078 84.272 60.5795Z",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.7637 16.1934H66.6106V27.6344H67.7637V16.1934Z",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.7637 30.7271H66.6106V37.295H67.7637V30.7271Z",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.236 41.1635H170.389V29.7224H169.236V41.1635Z",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.236 26.63H170.389V20.062H169.236V26.63Z",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.499756 56.2356H67.1869V57.3953H0.499756V56.2356Z",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.6238 59.7139H67.1872V60.8736H46.6238V59.7139Z",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4019 59.7139H38.936V60.8736H32.4019V59.7139Z",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.812 56.2356H236.5V57.3953H169.812V56.2356Z",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.309 59.7139H202.296V60.8736H182.309V59.7139Z",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.748 59.7139H218.819V60.8736H210.748V59.7139Z",
    fill: "#8E8E8E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_118_5747"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 236,
    height: 86,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyBox);
export default __webpack_public_path__ + "static/media/emptyBox.b4cf5f3131622db4e282dc8ab3f2f1f3.svg";
export { ForwardRef as ReactComponent };